export class ApiError extends Error {
    code;
    status;
    constructor(message, code, status) {
        super(message);
        this.name = 'ApiError';
        this.code = code;
        this.status = status;
    }
}
async function request(path, init) {
    const response = await fetch(`/api${path}`, {
        credentials: 'same-origin',
        headers: init?.body ? { 'content-type': 'application/json' } : undefined,
        ...init,
    });
    let payload = null;
    try {
        payload = (await response.json());
    }
    catch {
        throw new ApiError(`服务器返回了非 JSON 响应（HTTP ${response.status}）`, 'bad_response', response.status);
    }
    if (!payload || payload.ok !== true) {
        const error = payload && payload.ok === false ? payload.error : undefined;
        throw new ApiError(error?.message ?? '请求失败', error?.code ?? 'unknown', response.status);
    }
    return payload.data;
}
function queryString(params) {
    const search = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value !== undefined && value !== '' && value !== 'all')
            search.set(key, value);
    }
    const text = search.toString();
    return text ? `?${text}` : '';
}
export const api = {
    me: () => request('/auth/me'),
    login: (username, password) => request('/auth/login', { method: 'POST', body: JSON.stringify({ username, password }) }),
    logout: () => request('/auth/logout', { method: 'POST' }),
    health: () => request('/health'),
    exams: (filters = {}) => request(`/exams${queryString(filters)}`),
    exam: (examId) => request(`/exams/${encodeURIComponent(examId)}`),
    examAttempts: (examId) => request(`/exams/${encodeURIComponent(examId)}/attempts`),
    startAttempt: (examId) => request('/attempts', {
        method: 'POST',
        body: JSON.stringify({ examId, mode: 'practice' }),
    }),
    saveDraft: (attemptId, payload) => request(`/attempts/${attemptId}/draft`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
    }),
    submitAttempt: (attemptId, durationMs, payload) => request(`/attempts/${attemptId}/submit`, {
        method: 'POST',
        body: JSON.stringify({ durationMs, payload }),
    }),
    review: (attemptId) => request(`/attempts/${encodeURIComponent(attemptId)}`),
    attempts: () => request('/attempts'),
    mistakes: (filters = {}) => request(`/mistakes${queryString(filters)}`),
    updateMistake: (id, patch) => request(`/mistakes/${encodeURIComponent(id)}`, {
        method: 'PATCH',
        body: JSON.stringify(patch),
    }),
    stats: () => request('/stats/overview'),
    // ---- 标注（练习页只作用于文章；精读页还可以标注题干与选项） ----
    annotations: (examId) => request(`/annotations?examId=${encodeURIComponent(examId)}`),
    createAnnotation: (input) => request('/annotations', { method: 'POST', body: JSON.stringify(input) }),
    updateAnnotation: (id, patch) => request(`/annotations/${encodeURIComponent(id)}`, {
        method: 'PATCH',
        body: JSON.stringify(patch),
    }),
    deleteAnnotation: (id) => request(`/annotations/${encodeURIComponent(id)}`, { method: 'DELETE' }),
    // ---- 逐题对比 ----
    compareAttempts: (baseId, targetId) => request(`/attempts/compare?baseId=${encodeURIComponent(baseId)}&targetId=${encodeURIComponent(targetId)}`),
};
//# sourceMappingURL=api.js.map